import type {
  ComponentDescription,
  ComponentInstance,
  NodeRedFlow,
  NodeRedFlowTab,
} from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import getComponentLogicTabId from '../../logic/getComponentLogicTabId';

export default function migrateComponentInstanceLogicFlows(
  flows: NodeRedFlow[],
  viewId: number,
  componentInstance: ComponentInstance,
  description?: ComponentDescription,
): NodeRedFlow[] {
  const componentLogicBaseId = getComponentLogicTabId(viewId, componentInstance.id);
  const componentLogicIsolatedId = `${componentLogicBaseId}:isolated`;
  const componentLogicTabName = `Component: ${componentInstance.display_name}`;
  let migratedOwnFlows = flows.map((flow) => {
    if (flow.type === 'tab') {
      if (flow.id === componentLogicBaseId || flow.id === componentLogicIsolatedId) {
        // Ensure the logic tab name is up-to-date
        return {
          ...flow,
          label: componentLogicTabName,
        };
      }
    }
    return flow;
  });
  // Ensure that a composite component instance has its (outer) logic tab
  if (!migratedOwnFlows.some((flow) => flow.id === componentLogicBaseId)) {
    const tab: NodeRedFlowTab = {
      id: componentLogicBaseId,
      type: 'tab',
      label: componentLogicTabName,
    };
    migratedOwnFlows = [...migratedOwnFlows, tab];
  }
  if (description) {
    if (description.composite_json) {
      // Ensure that a composite component instance has the `:isolated` logic tab
      if (!migratedOwnFlows.some((flow) => flow.id === componentLogicIsolatedId)) {
        const isolatedTab: NodeRedFlowTab = {
          id: componentLogicIsolatedId,
          type: 'tab',
          label: componentLogicTabName,
        };
        migratedOwnFlows = [...migratedOwnFlows, isolatedTab];
      }
    } else {
      // Ensure that non-composite component instances do NOT have the `:isolated` logic tab nor logic
      migratedOwnFlows = migratedOwnFlows.filter((flow) => {
        if (flow.id === componentLogicIsolatedId) return false;
        if ('z' in flow && flow.z === componentLogicIsolatedId) return false;
        return true;
      });
    }
  }
  // Migrate recursively for any nested components
  return componentInstance.children.reduce(
    (resultFlows, child) => migrateComponentInstanceLogicFlows(resultFlows, viewId, child),
    migratedOwnFlows,
  );
}
